<template>
  <img
    :src="quiz.get('card').get('filePath')"
    class="found-card"
    >
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  computed: {
    quiz: function () {
      return this.$store.state.quiz.quiz
    }
  }
}
</script>

<style lang="scss" scoped>
.found {
  display: flex;
  justify-content: center;

  &-card {
    box-sizing: border-box;
    max-height: 200px;
    margin: 20px;
  }
}
</style>

